import {ApiFindOptions, useApiFind} from "../../../../../lib/HttpService";
import {PATH} from "./const";
import { PATH as ROSTER_PATH } from '../const';
import {StubbornSessionConfiguration} from "../../../../../application/business/StubbornConfiguration";

export const useRosterSessionConfigurationContextFind = (options: ApiFindOptions = {}) => useApiFind<Pick<StubbornSessionConfiguration, 'name' | 'description' | 'header' | 'type'>>(`${ROSTER_PATH}${PATH}`, options);
